import { render, staticRenderFns } from "./CustomerCase.vue?vue&type=template&id=6d64d79c&scoped=true&"
import script from "./CustomerCase.vue?vue&type=script&lang=js&"
export * from "./CustomerCase.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCase.vue?vue&type=style&index=0&id=6d64d79c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d64d79c",
  null
  
)

export default component.exports